import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { BREAKPOINTS } from '../BeFi20/BeFi20.meta';

export const Wrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  width: '100%',
  background: theme.background,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
}));

export const StepCard = styled(motion.section)(({ theme }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  padding: 16,
  background: theme.colors.bg,
  flex: 1,

  [`@media (min-width: ${BREAKPOINTS.sm})`]: {
    borderRadius: 12,
    boxShadow: theme.shadows['500'],
    maxWidth: 640,
    padding: 32,
    width: '100%',
    margin: '40px auto',
    flex: 'unset',
  },
}));
